import { render } from "./MineSweep copy.vue?vue&type=template&id=93ce7a4e"
import script from "./MineSweep copy.vue?vue&type=script&lang=js"
export * from "./MineSweep copy.vue?vue&type=script&lang=js"

import "./MineSweep copy.vue?vue&type=style&index=0&id=93ce7a4e&lang=css"

import exportComponent from "/builds/games/game.xiaofei.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__